// H5活动打点
import API from "../../api/API";
import Utils from "./utils";
import wifiApi from "./wifiApi";

class ReportData {
  constructor(config = {}) {
    this.allParam = Utils.getAllParam()
    this.report_ele = config['report_ele'] || '.report'
    this.scrollReport = config['scroll_report']
    this.report_page = config['page'] || Utils.getPage()
    this.userId = ''
    this.devicedId = ''

    let _this = this

    if (window.wkb && wifiApi.isWifiBrowser()) { // 钥匙浏览器
      window.wkb.call('getAppInfo', {
        success: function (appInfo) {
          console.log('appInfo', appInfo)
          _this.allParam = $.extend({}, _this.allParam, appInfo || {})

          // 曝光打点
          _this.report('show', {
            unsafe_action: 'page_show',
            page: _this.report_page
          })
        }
      })
    } else {
      // 曝光打点
      _this.report('show', {
        unsafe_action: 'page_show',
        page: this.report_page
      })
    }

    
    

    // 滑屏打点
    if (this.scrollReport) {
      let timeout = null
      $(window).off().on('scroll', function () {
        if (timeout) { clearTimeout(timeout); }
        timeout = setTimeout(() => {
          let res = $.extend({}, {
            starttime: new Date().getTime(),
            unsafe_action: 'page_scroll',
            page: _this.report_page,
            scroll_top: $(this).scrollTop()
          })
          _this.report('click', res)
        }, 200);
      })
    }
    
    
    // 点击上报click
    $('body').on('click', this.report_ele, function () {
      _this.reportClickData($(this))
    })
  }


  // 点击上报事件
  reportClickData (ele) {
    let res = $.extend({}, { 
      starttime: new Date().getTime(),
      unsafe_action: 'item_click',
      page: this.report_page,
      scbookid: ele.data('scbookid') || ele.data('itemid') || '',
    }, ele[0].dataset)
    this.report('click', res)
  }

  // 点击元素曝光事件
  reportShowData (ele) {
    let res = $.extend({}, {
      starttime: new Date().getTime(),
      unsafe_action: 'item_show',
      page: this.report_page,
      scbookid: ele.data('scbookid') || ele.data('itemid') || '',
    }, ele[0].dataset)
    this.report('show', res)
  }

  reportOtherData (params) {
    let res = $.extend({}, {
      starttime: new Date().getTime()
    }, params)
    this.report('click', res)
  }

  report (action, params = {}) {
    // source action ext必传，ext是字符串
    // did，acid如果URL中有直接拿，如果没有最好wkr获取，选传
    // packageName 用来更好区分哪个APP  选传
    console.log('开始打点===>' + action)
    let ext = JSON.stringify($.extend({}, this.allParam, params))
    let data = {
      source: 'h5',
      action: action,
      did: this.allParam.did || this.userId || '',
      acid: this.allParam.acid || this.devicedId || '',
      ext: ext || ''
    }
    console.log('开始打点data===>' + JSON.stringify(data))
    $.ajax({
      type: "POST",
      url: API.report_unsafe,
      data: data,
      success: (res) => {
        console.log(res)
      },
      error: (err) => {
        console.log(err)
      }
    })
  }
}

export default ReportData


// WEBPACK FOOTER //
// ./src/common/js/report_unsafe.js